import type { ReactNode } from "react";

export function HeroVorgangSystemLog(props: {
  readonly text: string;
  readonly date: string;
}): ReactNode {
  return (
    <div
      style={{
        textAlign: "center",
        fontSize: 11,
        lineHeight: 1.45,
        color: "rgba(11,15,25,0.45)",
        padding: "4px 12px",
      }}
    >
      {props.text}{" "}
      <span style={{ color: "rgba(11,15,25,0.38)" }}>{props.date}</span>
    </div>
  );
}
